// extracted by mini-css-extract-plugin
module.exports = {"activeMic":"AudioButton_activeMic__V_T6R","spin360":"AudioButton_spin360__1u46V"};